import React from 'react';

function TrustedLogoAgency({ setView }) {
  const handleHomeClick = (e) => {
    e.preventDefault();
    if (setView) {
      if (window.location.pathname !== '/') {
        window.history.pushState({}, '', '/');
      }
      setView('home');
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      window.location.href = '/';
    }
  };

  const handleDiscussClick = (e) => {
    e.preventDefault();
    const formEl = document.getElementById('logo-hero-form') || document.querySelector('.contact-section');
    if (formEl) {
      formEl.scrollIntoView({ behavior: 'smooth' });
    } else {
      window.location.href = '/contact/';
    }
  };

  return (
    <section className="trusted-agency-section">
      <div className="container trusted-agency-container">
        {/* Left Column: Content */}
        <div className="trusted-agency-left">
          <h2 className="trusted-agency-title">
            Make A Difference With a Trusted <span className="text-red">Logo Design Agency In Pakistan</span>
          </h2>

          <p className="trusted-agency-desc">
            A quality logo design company works best for branding and marketing strategy. If you have a good logo, you can build strong brand recognition for your firm. It will also shape the way customers perceive your business. <a href="/" onClick={handleHomeClick} className="text-red font-semibold">Experts Communication</a> presents the best logo design solutions that express the proper idea of your brand.
          </p>

          <p className="trusted-agency-desc">
            Reach out to us today to get personalized designing and marketing solutions and learn how we can help your brand grow digitally.
          </p>

          <button className="btn-trusted-agency-action" onClick={handleDiscussClick}>
            Let's Discuss Your Needs
          </button>
        </div>

        {/* Right Column: Image */}
        <div className="trusted-agency-right">
          <div className="trusted-agency-img-wrapper">
            <img 
              src="/assets/images/logo-des/logo-img2.png" 
              alt="Trusted Logo Design Agency in Pakistan Showcase" 
              className="trusted-agency-img"
            />
          </div>
        </div>
      </div>
    </section>
  );
}

export default TrustedLogoAgency;
